"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.avatarIconSize = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SystemIcon = _interopRequireDefault(require("../../../protons/icons/SystemIcon"));

var _MidRendererIcon = _interopRequireDefault(require("../../../protons/icons/MidRendererIcon"));

var _HiFiIcon = _interopRequireDefault(require("../../../protons/icons/HiFiIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.common.white
    },
    xxsmall: {
      width: 24,
      height: 24,
      "& .MuiSvgIcon-root": {
        width: 18,
        height: 18
      }
    },
    xsmall: {
      width: 32,
      height: 32,
      "& .MuiSvgIcon-root": {
        width: 18,
        height: 18
      }
    },
    small: {
      width: 36,
      height: 36,
      "& .MuiSvgIcon-root": {
        width: 24,
        height: 24
      }
    },
    medium: {
      width: 48,
      height: 48,
      "& .MuiSvgIcon-root": {
        width: 32,
        height: 32
      }
    },
    large: {
      width: 64,
      height: 64,
      "& .MuiSvgIcon-root": {
        width: 32,
        height: 32
      }
    },
    xlarge: {
      width: 84,
      height: 84
    },
    xxlarge: {
      width: 120,
      height: 120,
      "& .MuiSvgIcon-root": {
        width: 72,
        height: 72
      }
    }
  };
});
/**
 * **Avatars are used to quickly identify users, groups or products.**
 *
 * There are 6 sizes: xxsmall, xsmall, small, medium, large", xlarge", xxlarge
 */

var AvatarIcon = function AvatarIcon(_ref) {
  var _classNames;

  var _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? "ic_2g" : _ref$icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size;
  var styles = useStyles();

  var renderIconComponent = function renderIconComponent() {
    if (size === "xlarge") return /*#__PURE__*/_react.default.createElement(_MidRendererIcon.default, {
      icon: icon
    });
    if (size === "xxlarge") return /*#__PURE__*/_react.default.createElement(_HiFiIcon.default, {
      icon: icon
    });
    return /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
      icon: icon,
      color: "grey"
    });
  };

  return /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.root, true), _defineProperty(_classNames, styles[size], true), _classNames))
  }, renderIconComponent());
};

AvatarIcon.propTypes = {
  /** The key of the Icon component (xxlarge uses HiFiKeys, xlarge uses MidRenderKeys, all the other sizes uses SystemIconKeys) */
  icon: _propTypes.default.string.isRequired,

  /** The size of the avatar (32px, 36px, 48px, 64px, 84px, 120px) */
  size: _propTypes.default.oneOf(["xxsmall", "xsmall", "small", "medium", "large", "xlarge", "xxlarge"])
};
AvatarIcon.defaultProps = {
  size: "medium"
};
var avatarIconSize = ["xxsmall", "xsmall", "small", "medium", "large", "xlarge", "xxlarge"];
exports.avatarIconSize = avatarIconSize;
var _default = AvatarIcon;
exports.default = _default;